import React from "react";
import "./Chip.css";

const Chip = ({ text }) => {
	return <span className="chip">{text}</span>;
};

export default Chip;
